// @TODO WMG1-409 Convert colors to tokens.
export const BACKGROUND_COLORS = [
  'bg-[0.577_0.2144_260.86]',
  'bg-[0.839_0.1673_82.66]',
  'bg-[0.701_0.2435_344.02]',
  'bg-[0.9055_0.1466_184.72]',
  'bg-[0.6053_0.2701_306.02]',
];

export const TEXT_COLORS = [
  'text-[0.577_0.2144_260.86]',
  'text-[0.839_0.1673_82.66]',
  'text-[0.701_0.2435_344.02]',
  'text-[0.9055_0.1466_184.72]',
  'text-[0.6053_0.2701_306.02]',
];
